import React from 'react'
import ProgrammeForm from './ProgrammeForm';
import { usePermissionGuardRedirect } from '../../../hooks/usePermissionGuard';

function Details({ setEnableAutodesk, enableAutodesk, enableProgramOverview, setEnableProgramOverview, programmeFunction, timeTableDoc, timeTableDocName, setTimeTableDoc, setTimeTableDocName, programmeData, refresh, setRefresh }) {
  usePermissionGuardRedirect(['capview']);

  return (
    <div>
      <ProgrammeForm setEnableAutodesk={setEnableAutodesk} enableAutodesk={enableAutodesk} enableProgramOverview={enableProgramOverview} setEnableProgramOverview={setEnableProgramOverview} programmeFunction={programmeFunction} timeTableDoc={timeTableDoc} timeTableDocName={timeTableDocName} setTimeTableDoc={setTimeTableDoc} setTimeTableDocName={setTimeTableDocName} programmeData={programmeData} refresh={refresh} setRefresh={setRefresh} />
    </div>
  )
}

export default Details
